export const toastTheme = {
  root: {
    borderRadius: 'var(--border-radius)',
  },
  borderWidth: 'var(--reset)',
  content: {
    padding: 'var(--rem)',
  },
  transitionDuration: '0.2s',
  icon: {
    size: 'var(--two-rem)',
  },
  detail: {
    fontSize: 'var(--font-size-body)',
  },
  closeButton: {
    width: 'var(--two-rem)',
    height: 'var(--two-rem)',
    borderRadius: 'var(--pct-50)',
    focusRing: {
      offset: 'var(--reset)',
    },
  },
  extend: {
    agility: {
      fontSize: 'var(--font-size-sm)',
    },
  },
  colorScheme: {
    light: {
      info: {
        icon: {
          color: 'var(--primary-color)',
        },
        background: 'var(--p-primary-100)',
        color: 'var(--p-primary-800)',
        shadow: 'var(--overlay-box-shadow)',
        borderColor: 'var(--primary-color)',
      },
      success: {
        icon: {
          color: 'var(--p-success-500)',
        },
        background: 'var(--p-success-0)',
        color: 'var(--p-success-900)',
        shadow: 'var(--overlay-box-shadow)',
        borderColor: 'var(--p-success-500)',
      },
      warn: {
        icon: {
          color: 'var(--p-warning-500)',
        },
        background: 'var(--p-warning-0)',
        color: 'var(--p-warning-900)',
        shadow: 'var(--overlay-box-shadow)',
        borderColor: 'var(--p-warning-500)',
      },
      error: {
        icon: {
          color: 'var(--p-danger-500)',
        },
        background: 'var(--p-danger-0)',
        color: 'var(--p-danger-900)',
        shadow: 'var(--overlay-box-shadow)',
        borderColor: 'var(--p-danger-500)',
      },
    },
    dark: {
      info: {
        icon: {
          color: 'var(--primary-color)',
        },
        background: 'var(--p-primary-900)',
        color: 'var(--p-primary-800)',
        shadow: 'var(--overlay-box-shadow)',
        borderColor: 'var(--primary-color)',
      },
      success: {
        icon: {
          color: 'var(--p-success-500)',
        },
        background: 'var(--p-success-900)',
        color: 'var(--p-success-900)',
        shadow: 'var(--overlay-box-shadow)',
        borderColor: 'var(--p-success-500)',
      },
      warn: {
        icon: {
          color: 'var(--p-warning-500)',
        },
        background: 'var(--p-warning-900)',
        color: 'var(--p-warning-900)',
        shadow: 'var(--overlay-box-shadow)',
        borderColor: 'var(--p-warning-500)',
      },
      error: {
        icon: {
          color: 'var(--p-danger-500)',
        },
        background: 'var(--p-danger-900)',
        color: 'var(--p-white)',
        shadow: 'var(--overlay-box-shadow)',
        borderColor: 'var(--p-danger-500)',
      },
    },
  },
  css: ({ dt }: any) => `
  .p-toast-message.p-toast-message-info i {
    color: ${dt('toast.info.icon.color')};
  }
  .p-toast-message.p-toast-message-success i {
    color: ${dt('toast.success.icon.color')};
  }
  .p-toast-message.p-toast-message-warn i {
    color: ${dt('toast.warn.icon.color')};
  }
  .p-toast-message.p-toast-message-error i {
    color: ${dt('toast.error.icon.color')};
  }
  `,
};
